import { createToaster } from "@chakra-ui/react";

export const toaster = createToaster({
  placement: "bottom",
  pauseOnPageIdle: true,
  overlap: true,
});

type ToastStatus = "success" | "error" | "warning" | "info" | "loading";

export interface ToastOptions {
  title?: React.ReactNode;
  description?: React.ReactNode;
  status?: ToastStatus;
  duration?: number;
  isClosable?: boolean;
}

export const toast = ({
  title,
  description,
  status = "info",
  duration = 4000,
  isClosable = true,
}: ToastOptions) =>
  toaster.create({
    title,
    description,
    type: status,
    duration,
    closable: isClosable,
  });
